// web/src/i18n/index.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import namespace files for each language
// Common namespace (always loaded)
import enCommon from './locales/en/common.json';
import deCommon from './locales/de/common.json';
import frCommon from './locales/fr/common.json';
import itCommon from './locales/it/common.json';

// Dashboard namespace
import enDashboard from './locales/en/dashboard.json';
import deDashboard from './locales/de/dashboard.json';
import frDashboard from './locales/fr/dashboard.json';
import itDashboard from './locales/it/dashboard.json';

// Scans namespace
import enScans from './locales/en/scans.json';
import deScans from './locales/de/scans.json';
import frScans from './locales/fr/scans.json';
import itScans from './locales/it/scans.json';

// Projects namespace
import enProjects from './locales/en/projects.json';
import deProjects from './locales/de/projects.json';
import frProjects from './locales/fr/projects.json';
import itProjects from './locales/it/projects.json';

// Results namespace
import enResults from './locales/en/results.json';
import deResults from './locales/de/results.json';
import frResults from './locales/fr/results.json';
import itResults from './locales/it/results.json';

// Admin namespace
import enAdmin from './locales/en/admin.json';
import deAdmin from './locales/de/admin.json';
import frAdmin from './locales/fr/admin.json';
import itAdmin from './locales/it/admin.json';

// Reports namespace
import enReports from './locales/en/reports.json';
import deReports from './locales/de/reports.json';
import frReports from './locales/fr/reports.json';
import itReports from './locales/it/reports.json';

// Schedules namespace
import enSchedules from './locales/en/schedules.json';
import deSchedules from './locales/de/schedules.json';
import frSchedules from './locales/fr/schedules.json';
import itSchedules from './locales/it/schedules.json';

// Discovery namespace
import enDiscovery from './locales/en/discovery.json';
import deDiscovery from './locales/de/discovery.json';
import frDiscovery from './locales/fr/discovery.json';
import itDiscovery from './locales/it/discovery.json';

// Security namespace
import enSecurity from './locales/en/security.json';
import deSecurity from './locales/de/security.json';
import frSecurity from './locales/fr/security.json';
import itSecurity from './locales/it/security.json';

// VulnData namespace
import enVulnData from './locales/en/vulnData.json';
import deVulnData from './locales/de/vulnData.json';
import frVulnData from './locales/fr/vulnData.json';
import itVulnData from './locales/it/vulnData.json';

// Help namespace
import enHelp from './locales/en/help.json';
import deHelp from './locales/de/help.json';
import frHelp from './locales/fr/help.json';
import itHelp from './locales/it/help.json';

// AI namespace
import enAI from './locales/en/ai.json';
import deAI from './locales/de/ai.json';
import frAI from './locales/fr/ai.json';
import itAI from './locales/it/ai.json';

// Auth namespace (MFA, login, etc.)
import enAuth from './locales/en/auth.json';
import deAuth from './locales/de/auth.json';
import frAuth from './locales/fr/auth.json';
import itAuth from './locales/it/auth.json';

// Findings namespace (Exposure Monitoring, etc.)
import enFindings from './locales/en/findings.json';
import deFindings from './locales/de/findings.json';
import frFindings from './locales/fr/findings.json';
import itFindings from './locales/it/findings.json';

// Tickets namespace
import enTickets from './locales/en/tickets.json';
import deTickets from './locales/de/tickets.json';
import frTickets from './locales/fr/tickets.json';
import itTickets from './locales/it/tickets.json';

// Compliance namespace (Swiss FINMA/nDSG)
import enCompliance from './locales/en/compliance.json';
import deCompliance from './locales/de/compliance.json';
import frCompliance from './locales/fr/compliance.json';
import itCompliance from './locales/it/compliance.json';

// Integrations namespace (Webhooks, Notifications)
import enIntegrations from './locales/en/integrations.json';
import deIntegrations from './locales/de/integrations.json';
import frIntegrations from './locales/fr/integrations.json';
import itIntegrations from './locales/it/integrations.json';

// Baseline namespace
import enBaseline from './locales/en/baseline.json';
import deBaseline from './locales/de/baseline.json';
import frBaseline from './locales/fr/baseline.json';
import itBaseline from './locales/it/baseline.json';

// MITRE ATT&CK and Priority namespace
import enMitre from './locales/en/mitre.json';
import deMitre from './locales/de/mitre.json';
import frMitre from './locales/fr/mitre.json';
import itMitre from './locales/it/mitre.json';

// Client Templates namespace
import enClientTemplates from './locales/en/clientTemplates.json';
import deClientTemplates from './locales/de/clientTemplates.json';
import frClientTemplates from './locales/fr/clientTemplates.json';
import itClientTemplates from './locales/it/clientTemplates.json';

// Clients namespace (Client management)
import enClients from './locales/en/clients.json';
import deClients from './locales/de/clients.json';
import frClients from './locales/fr/clients.json';
import itClients from './locales/it/clients.json';

// Subscription namespace (Registration, Plans, Trial, GTC)
import enSubscription from './locales/en/subscription.json';
import deSubscription from './locales/de/subscription.json';
import frSubscription from './locales/fr/subscription.json';
import itSubscription from './locales/it/subscription.json';

// Client Reviews namespace
import enClientReviews from './locales/en/clientReviews.json';
import deClientReviews from './locales/de/clientReviews.json';
import frClientReviews from './locales/fr/clientReviews.json';
import itClientReviews from './locales/it/clientReviews.json';

// Alerting namespace (consolidated notification settings)
import enAlerting from './locales/en/alerting.json';
import deAlerting from './locales/de/alerting.json';
import frAlerting from './locales/fr/alerting.json';
import itAlerting from './locales/it/alerting.json';

// Breach Monitoring namespace
import enBreach from './locales/en/breach.json';
import deBreach from './locales/de/breach.json';
import frBreach from './locales/fr/breach.json';
import itBreach from './locales/it/breach.json';

// Deep merge all namespaces into a single translation object per language
// Shallow spread was causing conflicts (e.g. ai.json's "dashboard" key overwrote dashboard.json's)
const deepMerge = (target: Record<string, unknown>, source: Record<string, unknown>): Record<string, unknown> => {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (
      result[key] &&
      typeof result[key] === 'object' &&
      !Array.isArray(result[key]) &&
      typeof source[key] === 'object' &&
      !Array.isArray(source[key])
    ) {
      result[key] = deepMerge(result[key] as Record<string, unknown>, source[key] as Record<string, unknown>);
    } else {
      result[key] = source[key];
    }
  }
  return result;
};

const mergeNamespaces = (...namespaces: Record<string, unknown>[]) => {
  return namespaces.reduce((acc, ns) => deepMerge(acc, ns), {} as Record<string, unknown>);
};

export const resources = {
  en: {
    translation: mergeNamespaces(
      enCommon,
      enDashboard,
      enScans,
      enProjects,
      enResults,
      enAdmin,
      enReports,
      enSchedules,
      enDiscovery,
      enSecurity,
      enVulnData,
      enHelp,
      enAI,
      enAuth,
      enFindings,
      enTickets,
      enCompliance,
      enIntegrations,
      enBaseline,
      enMitre,
      enClientTemplates,
      enClients,
      enSubscription,
      enClientReviews,
      enAlerting,
      enBreach
    ),
    auth: enAuth,
    findings: enFindings,
    tickets: enTickets,
    clients: enClients,
    schedules: enSchedules,
    subscription: enSubscription,
    admin: enAdmin,
    alerting: enAlerting,
    breach: enBreach,
  },
  de: {
    translation: mergeNamespaces(
      deCommon,
      deDashboard,
      deScans,
      deProjects,
      deResults,
      deAdmin,
      deReports,
      deSchedules,
      deDiscovery,
      deSecurity,
      deVulnData,
      deHelp,
      deAI,
      deAuth,
      deFindings,
      deTickets,
      deCompliance,
      deIntegrations,
      deBaseline,
      deMitre,
      deClientTemplates,
      deClients,
      deSubscription,
      deClientReviews,
      deAlerting,
      deBreach
    ),
    findings: deFindings,
    tickets: deTickets,
    clients: deClients,
    schedules: deSchedules,
    subscription: deSubscription,
    admin: deAdmin,
    alerting: deAlerting,
    breach: deBreach,
  },
  fr: {
    translation: mergeNamespaces(
      frCommon,
      frDashboard,
      frScans,
      frProjects,
      frResults,
      frAdmin,
      frReports,
      frSchedules,
      frDiscovery,
      frSecurity,
      frVulnData,
      frHelp,
      frAI,
      frAuth,
      frFindings,
      frTickets,
      frCompliance,
      frIntegrations,
      frBaseline,
      frMitre,
      frClientTemplates,
      frClients,
      frSubscription,
      frClientReviews,
      frAlerting,
      frBreach
    ),
    findings: frFindings,
    tickets: frTickets,
    clients: frClients,
    schedules: frSchedules,
    subscription: frSubscription,
    admin: frAdmin,
    alerting: frAlerting,
    breach: frBreach,
  },
  it: {
    translation: mergeNamespaces(
      itCommon,
      itDashboard,
      itScans,
      itProjects,
      itResults,
      itAdmin,
      itReports,
      itSchedules,
      itDiscovery,
      itSecurity,
      itVulnData,
      itHelp,
      itAI,
      itAuth,
      itFindings,
      itTickets,
      itCompliance,
      itIntegrations,
      itBaseline,
      itMitre,
      itClientTemplates,
      itClients,
      itSubscription,
      itClientReviews,
      itAlerting,
      itBreach
    ),
    findings: itFindings,
    tickets: itTickets,
    clients: itClients,
    schedules: itSchedules,
    subscription: itSubscription,
    admin: itAdmin,
    alerting: itAlerting,
    breach: itBreach,
  },
};

export const supportedLanguages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'vulnscanner_language',
    },
  });

export default i18n;
